import { Link } from "react-router-dom";

const NotFoundPage = () => {
  return (
    <div
      className="flex flex-col items-center justify-center bg-gray-100"
      style={{ minHeight: "calc(100vh - 21.5rem)" }}
    >
      <h1 className="text-4xl font-bold text-gray-800 mb-4">404</h1>
      <p className="text-lg text-gray-600 mb-6">
        Trang bạn tìm kiếm không tồn tại.
      </p>
      <Link
        to="/"
        className="px-6 py-3 text-white bg-primaryColor hover:bg-primaryColor/80 rounded-md"
      >
        Về Trang chủ
      </Link>
    </div>
  );
};

export default NotFoundPage;
